import MuiAlert, { AlertProps, AlertColor } from "@mui/material/Alert";

const Alert: React.FC<AlertProps> = MuiAlert;

export default Alert;
export type { AlertProps, AlertColor };
